import { useEffect } from 'react';
import { useRouter } from 'next/router';
/*
 * 百度统计工具方法
 * 负责封装对 window._hmt 的直接操作，避免业务代码散落接入细节。
 */

const isGaEnv = process.env.ENV === 'zjga';

function getHmt(): any[] | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const hmt = (window as any)._hmt;

  if (!hmt) {
    return null;
  }

  return hmt;
}

/**
 * 上报页面浏览埋点
 * 等价于：window._hmt && window._hmt.push(['_trackPageview', url])
 */
export function trackPageView(url: string): void {
  if (!isGaEnv) {
    return;
  }

  try {
    const hmt = getHmt();

    if (!hmt) {
      return;
    }

    hmt.push(['_trackPageview', url]);
  } catch (error) {
    // ignore
  }
}

/*
 * 在指定环境下（zjga），监听 Next.js 路由变化并上报百度 PV。
 * 封装为自定义 Hook，避免在各个组件中重复编写监听逻辑。
 */

export function useBaiduPv(): void {
  const router = useRouter();

  useEffect(() => {
    if (!isGaEnv) {
      return;
    }

    const handleRouteChange = (url: string) => {
      // 百度统计上报
      trackPageView(url);
    };

    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);
}
